'use client';
import { hydrate } from '@wagmi/core';
import { useEffect, useRef } from 'react';
export function Hydrate(parameters) {
    const { children, config, initialState, reconnectOnMount = true } = parameters;
    const { onMount } = hydrate(config, {
        initialState,
        reconnectOnMount,
    });
    // Hydrate for non-SSR
    if (!config._internal.ssr)
        onMount();
    // Hydrate for SSR
    const active = useRef(true);
    // biome-ignore lint/correctness/useExhaustiveDependencies: `queryKey` not required
    useEffect(() => {
        if (!active.current)
            return;
        if (!config._internal.ssr)
            return;
        onMount();
        return () => {
            active.current = false;
        };
    }, []);
    return children;
}
//# sourceMappingURL=hydrate.js.map